export default {
	// Custom Page Meta
	seo_meta_title_leaguepass: 'League Pass – NBAのライブ中継を配信 | NBA.com',
	seo_meta_desc_leaguepass: 'NBA League PassでNBAの試合をライブとオンデマンドで視聴。こちらからアカウントにアクセスしてください。',
	seo_meta_keywords_leaguepass: 'NBA ビデオ、NBA ハイライト、バスケットボール ビデオ、トップ プレイ、ダンク、フィーチャー',
	seo_meta_title_featured: 'NBAの試合をストリーミング＆ハイライトを視聴 | NBA.com',
	seo_meta_desc_featured: 'NBAの動画ハイライト、ニュース、分析を無料視聴。さらに、NBA TV＆League Passサブスクリプションでお好きなデバイスからライブ中継を視聴。',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA TV - ライブ中継と番組に24時間アクセス | NBA.com',
	seo_meta_desc_nbatv: 'NBA TVのライブ放送を配信、クラシックゲームを視聴。さらに、リーグ関連のスタジオ番組や分析にもアクセス。',
	seo_meta_keywords_nbatv: 'NBA TV チャンネル、ザ ビート、ハードウッド クラシックス、nba ライブ、リアル nba、nba ゲームタイム、ファンタジー インサイダー、スタジオ ショー、ザ ジャンプ',
	seo_meta_title_classicgames: 'NBA TVほかでクラシックゲームをストリーミング | NBA.com',
	seo_meta_desc_classicgames: 'NBA TVでアイコニックなNBAのマッチアップを観戦。さらに、NBA TVのライブゲームをストリーミング、リーグ関連のスタジオ番組や分析にもアクセス。',
	seo_meta_keywords_classicgames: '',
	seo_meta_pre_title_videolist: 'こちらでコンテンツをストリーミング | NBA.com',
	seo_meta_title_videolist: 'こちらで{0}をストリーミング | NBA.com',
	seo_meta_desc_videolist: 'こちらで{0}の動画を視聴。また、お気に入りのデバイスでライブ試合を視聴するためにNBA TV＆League Passのサブスクリプションを確認できます。',
	seo_meta_title_videolist_show: 'NBA TVで{0}を配信 | NBA.com',
	seo_meta_desc_videolist_show: 'こちらから{0}を視聴。さらに、NBA TVのライブ放送を配信、クラシックゲームや分析にもアクセス。',
	seo_meta_keywords_videolist_show: '',
	seo_meta_title_videolist_feed: 'こちらで{0}をストリーミング | NBA.com',
	seo_meta_desc_videolist_feed: 'こちらで{0}の動画を視聴。さらに、NBA TV＆League Passサブスクリプションでお好きなデバイスでライブ試合を観戦。',
	seo_meta_keywords_videolist_feed: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'NBA TVほかでスタジオ番組をストリーミング | NBA.com',
	seo_meta_desc_shows: 'NBA TVの最新の番組とエピソードをオンデマンドストリーミング。さらに、NBA TVのライブゲームをストリーミング、クラシックゲームや分析にもアクセス。',
	seo_meta_keywords_shows: '',
	// Common Page Meta
	seo_meta_title_home: 'ホーム | NBA.com',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'チャンネル | NBA.com',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'チャンネル | NBA.com',
	seo_meta_pre_title_categories: 'カテゴリ | NBA.com',
	seo_meta_title_categories: 'カテゴリ | NBA.com',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'カテゴリ | NBA.com',
	seo_meta_title_category: 'カテゴリ | NBA.com',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'こちらで動画を配信 | NBA.com',
	seo_meta_pre_title_event: 'こちらでイベントを配信 | NBA.com',
	seo_meta_title_events: 'イベント | NBA.com',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'こちらで{0}をストリーミング | NBA.com',
	seo_meta_desc_event: 'ここから{0}を視聴。さらに、NBA TV＆League Passサブスクリプションでお好きなデバイスからライブゲームを観戦。',
	seo_meta_keywords_event: '',
	seo_meta_title_search: '検索 | NBA.com',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'ページが見つかりません | NBA.com',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'こちらで試合を配信 | NBA.com',
	seo_meta_title_game: 'こちらで{0}をストリーミング | NBA.com',
	seo_meta_desc_game: 'こちらで{0}の動画を視聴。さらに、NBA TV＆League Passサブスクリプションでお好きなデバイスでライブ試合を観戦。',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'こちらで{0}をストリーミング | NBA.com',
	seo_meta_desc_video: 'こちらで{0}の動画を視聴。さらに、NBA TV＆League Passサブスクリプションでお好きなデバイスでライブ試合を観戦。',
	seo_meta_keywords_video: 'NBA ビデオ、NBA ハイライト、バスケットボール ビデオ、トップ プレイ、ダンク、フィーチャー',
	seo_meta_title_episode: 'NBA TVで{0}を配信 | NBA.com',
	seo_meta_desc_episode: 'こちらで{0}を視聴。さらに、NBA TVのライブゲームをストリーミング、クラシックゲームや分析にアクセス。',
	seo_meta_keywords_episode: 'NBA ビデオ、NBA ハイライト、バスケットボール ビデオ、トップ プレイ、ダンク、フィーチャー',
	seo_meta_title_channel: 'NBA TVライブ | NBA.com',
	seo_meta_desc_channel: 'NBA TV Live は 24 時間いつでもライブ中継が楽しめる NBA TV のストリーミング配信サービスです。ライブ中継に加え、毎週追加されるアーカイブ配信、スタジオ プログラム、分析コンテンツなどさまざまなコンテンツをお楽しみいただけます。',
	seo_meta_keywords_channel: 'NBA TV チャンネル、ザ ビート、ハードウッド クラシックス、nba ライブ、リアル nba、nba ゲームタイム、ファンタジー インサイダー、スタジオ ショー、ザ ジャンプ',
	seo_meta_title_tvguide: 'NBA TVライブストリーミングのスケジュール | NBA.com',
	seo_meta_desc_tvguide: 'NBA TVで、お好きなデバイスからNBA TVのライブゲームとライブスタジオ番組を視聴できる時間を確認。さらに、オンデマンドのスタジオ番組と分析にアクセス。',
	seo_meta_keywords_tvguide: 'NBA TV チャンネル、ザ ビート、ハードウッド クラシックス、nba ライブ、リアル nba、nba ゲームタイム、ファンタジー インサイダー、スタジオ ショー、ザ ジャンプ',

	// Common
	timezone: 'ET',
	default_feed_error_message: '問題が発生しました。現在コンテンツを利用できません。もう一度お試しください。',
	watch_in_app: 'NBAアプリで視聴',
	ad_blocked_message: '広告ブロッカーが検出されました：NBA.comのコンテンツは、広告によってサポートされています。引き続きコンテンツをお楽しみいただくには、広告ブロッカーをオフにしてください。',

	// Item
	no_content: 'コンテンツがありません',
	see_more: 'もっと見る',
	now_playing: '再生中',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LPプレミアム',
	error_max_limit_favorite: 'お気に入りのビデオが上限数に達しました。ビデオを追加するにはお気に入りのビデオを削除する必要があります。',
	item_live: 'ライブ:',
	add_favourite_title: 'お気に入りに追加',
	remove_favourite_title: 'お気に入りから削除',
	// Channel: Schedule
	p_channel_live: 'ライブ:',
	p_channel_schedule_title: 'NBA TV放映スケジュール',
	p_channel_schedule_watch: '視聴する',
	p_channel_live24x7_title: 'NBA TV 24/7',
	p_channel_live24x7_see_full_schedule: 'すべての放映スケジュールを見る',
	p_channel_live24x7_up_next: 'up next',
	p_channel_live24x7_on_demand: 'NBA TV：オンデマンド',
	p_channel_live24x7_collection: 'コレクション',
	p_channel_live24x7_demand_1_logo_text: 'オリジナル番組',
	p_channel_live24x7_demand_1_show_name: 'NBA TV番組',
	p_channel_live24x7_demand_1_show_desc: '「Shaqtin’ a Fool」、「Beyond the Paint」、「Game Time」、「Basketball Stories」などのNBA TVオリジナル番組',
	p_channel_live24x7_demand_2_logo_text: 'クラシックゲーム',
	p_channel_live24x7_demand_2_show_name: 'NBA | クラシックゲーム',
	p_channel_live24x7_demand_2_show_desc: '2000年以降のファイナル全試合、リーグの歴史的瞬間、NBAレジェンドなど、過去の名勝負を完全版で配信',

	// Channel: Clips
	p_channel_error_msg: 'まだ利用できません',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'スケジュール',

	// NBA TV Shows:
	p_nba_tv_shows: 'NBA TV番組',
	p_nba_tv_no_access_title: '24/7 NBA：ゲーム分析、スタジオ解説、オリジナル番組など情報が盛りだくさん！',
	p_nba_tv_no_access_desc: '試合のライブ配信、オンデマンドの番組とクラシックゲームを視聴。',
	p_nba_tv_no_access_note: 'ブラックアウトが適用される場合があります',

	// tv show item
	tv_show_item_latest_episode: '最新のエピソード',
	tv_show_item_no_latest_episode: '最新のエピソードはありません',
	see_all: 'すべて表示',
	// header
	header_menu_watch: '視聴する',
	header_menu_featured: 'ピックアップ',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',

	// search
	players: '選手',
	videos: 'ビデオ',
	teams: 'チーム',
	most_searched: '検索数トップ',
	no_result: 'データがありません',
	search_filter_type_most_relevant: '関連順',
	search_filter_type_most_viewed: '視聴順',
	search_filter_type_most_recent: '日付順',
	search_filter_type_last_30_days: '過去30日間',
	search_filter_type_last_6_months: '過去6ヶ月間',
	search_result_label: '「{keyword}」の検索結果',
	search_result_info: '「{keyword}」の検索結果をすべて表示',
	search_placeholder: '動画ライブラリを検索',
	load_more: 'もっと読み込む...',

	// button
	button_subscribe: '申し込む',
	button_sign_in: 'サインイン',
	button_tv_provider: 'テレビプロバイダーを選択',

	// league page
	p_league_pass_no_access_title: 'コンピューターやスマートフォン、テレビなど、お好きなデバイスからライブまたはリピート再生で視聴！',
	p_league_pass_no_access_desc: 'アクションへの招待状：リーグ全体やお気に入りのチームを視聴、シングルゲームを選択、他にもオプション多数。',
	p_league_pass_no_access_note: '利用規約が適用されます',

	// Video
	category_title: 'ビデオ',
	p_video_playlist_title: 'プレイリスト:',
	p_video_episode_text: 'エピソード',
	p_no_access_league_pass_title: '視聴するには、NBA League Passのサブスクリプションを購入してください。',
	p_no_access_league_pass_premium_title: 'Unlock NBA League Pass Premium to watch:',
	p_no_access_league_pass_desc: 'アクションへの招待状：リーグ全体やお気に入りのチームを視聴、シングルゲームを選択、他にもオプション多数。',
	p_no_access_league_pass_terms: '利用規約が適用されます',
	p_no_access_league_pass_geo_desc: 'あなたの現在位置からはNBA League PassとNBA TVでこの試合を視聴できません。NBA League Passをご利用の方は、放送から3日後にアーカイブから視聴することができます。お住まいの地域での放送を確認するには、テレビおよびラジオ放送局のスケジュールをご覧ください。',
	p_no_access_league_pass_not_found_desc: '申し訳ありません。お探しの動画が見つかりませんでした。',
	p_no_access_event_geo_desc: 'この放送は、アメリカとカナダでは視聴できません。視聴するには、アメリカではESPN、カナダではTSNまたはSportsnetをご覧ください。',
	p_no_access_event_not_found_desc: '申し訳ありません。お探しのイベントが見つかりませんでした。',
	p_no_access_nba_tv_title: '視聴するには、NBA TVのサブスクリプションを購入してください。',
	p_no_access_nba_tv_desc: '試合のライブ配信、オンデマンドの番組とクラシックゲームを視聴。',
	p_no_access_nba_tv_terms: '利用規約が適用されます',
	p_no_access_nba_tv_geo_desc: 'あなたの現在位置からはNBA League PassとNBA TVでこの試合を視聴できません。NBA League Passをご利用の方は、放送から3日後にアーカイブから視聴することができます。お住まいの地域での放送を確認するには、テレビおよびラジオ放送局のスケジュールをご覧ください。',
	p_no_access_nba_tv_not_found_desc: '申し訳ありません。お探しのチャンネルが見つかりませんでした。',
	p_no_access_up_next: 'Up Next：',
	p_video_completed_title: 'プレイリストが完了しました',
	p_video_completed_desc: '戻ってブラウズするか、次のプレイリストをチェックしてください',
	p_video_share_to: '共有先：',
	p_video_more_to_watch: 'こちらもおすすめ：',

	// Event
	p_event_section_title: 'イベント',
	p_event_playlist_title: 'プレイリスト:',
	p_event_button_watch: '視聴する',
	p_event_button_listen: '聞く',
	p_event_button_ticket: 'チケット',

	// notfound page
	notfound: '要求されたページは見つかりませんでした。',
	notfound_desc: 'URL に誤りがないか確認してください。 <br/>サイト ナビゲーションまたは検索ツールを使って、お探しのコンテンツを見つけることもできます。',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'NBA League Passアカウントがストリーミング上限に達しました。このデバイスで視聴を続けるには、「続ける」をタップしてください。',
	modal_pcm_custom: '続ける',
	modal_pcm_close: 'キャンセル',
	modal_pcm_ok: 'オクラホマ州',

	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'この動画は、お使いのデバイスでは再生できません。お困りでしたら、<a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>こちら</a>をクリックしてください。',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'オクラホマ州',
	modal_video_unsupported_ok: 'オクラホマ州',

	// FreeSample
	freesample_notice_time: '残り時間',
	freesample_notice_title: 'アクセス時間{0}分をお楽しみください。',
	freesample_notice_desc: '{0}分終了後も、コンテンツへのアクセスを継続するためにLeague Passのフルパッケージを購読してください。',
	freesample_notice_subscribe_button: '申し込む',
	freesample_notice_cancel_button: 'いつでもキャンセル',
	freesample_popup_title: 'アクセス時間が終了しました',
	freesample_popup_subtitle: 'League Passに登録して、さらに多くの偉大なNBAのコンテンツを見ましょう。',
	freesample_popup_link: '詳しい情報をご覧ください！',
	freesample_popup_get_minutes_button: '{0} 分ゲット',

	// Video list
	reg_required_desc: 'このコンテンツを視聴するには、ログインする必要があります',
	favorite_teams_title: 'お気に入りのチーム',
	bookmarked_title: '保存しました',
	watch_history_title: '視聴を続ける',
	game_schedule_title: 'ゲームのスケジュール',
	recommended_title: 'おすすめ',
	season_text: 'シーズン',

	// profile page
	section_information_title: 'マイ情報',
	section_information_desc: '個人情報の更新',
	section_information_email: 'Eメール',
	section_information_email_update: 'メールアドレスの更新',
	section_information_password: 'パスワード',
	section_information_password_update: 'パスワードの変更',
	section_information_social: 'ソーシャル サービスへの接続',
	section_information_nosocial_message: 'リンクされたアカウントがありません。',
	section_information_firstname: '名',
	section_information_lastname: '姓',
	section_information_birth: '生年月日',
	section_information_country: '国/地域',
	section_information_postalcode: '郵便番号',
	section_information_edit: '編集',
	section_tv_provider_title: 'テレビプロバイダーの管理',
	section_tv_provider_desc: 'ご契約のテレビプロバイダーを経由して、試合のライブ配信やストリーミング配信にアクセスできます。',
	section_tv_provider_faq: 'テレビプロバイダーのよくあるご質問',
	section_tv_provider_sign_out: 'サインアウト',
	section_tv_provider_sign_in: 'テレビプロバイダーにサインイン',
	section_fantasy_title: 'ファンタジー',
	section_fantasy_desc: 'ファンタジーアカウント情報を見る',
	section_fantasy_displayname: '表示名',
	section_marketing_title: 'メール配信設定',
	section_marketing_desc: '広告コンテンツの配信およびユーザープライバシー設定を見る',
	section_marketing_newsletters: 'ニュースレター',
	section_marketing_message: 'NBAのメッセージと広告',
	section_marketing_newsletters_desc_1: 'NBAのニュースを毎日お届けします',
	section_marketing_newsletters_desc_2: 'NBA GリーグのニュースやNBA公式マイナーリーグの特集',
	section_marketing_newsletters_desc_3: 'Jr. NBAのニュースやNBAユースバスケットボールイニシアチブのコンテンツ',
	section_marketing_newsletters_desc_4: 'NBAアプリの最新機能、NBA League Passの最新情報や特典',
	section_marketing_newsletters_desc_5: 'NBAのチケットの特別割引、パートナー割引、イベントやグッズの割引',
	section_marketing_newsletters_desc_6: '厳選したNBAのニュースとコンテンツを毎週メールでお届け',
	section_marketing_newsletters_desc_7: 'WNBAとそのパートナーが提供するWNBAのニュースや割引',
	section_marketing_personal_title: '個人情報',
	section_marketing_personal_desc: 'NBAとNBAパートナーの製品とイニシアチブについてNBAからメッセージと広告を受け取るため、私の個人情報を提供します。',
	section_marketing_update_button: '広告設定の更新',
	section_marketing_update_success: '配信設定を更新しました。',
	section_ccpa_title: '個人情報の売却を許可しません',

	// profile edit modal
	email_modal_title: 'メールアドレスの更新',
	email_modal_new_email_label: '新しいメールアドレス',
	email_modal_update: '更新',
	email_modal_cancel: 'キャンセル',
	password_modal_title: 'パスワードの変更',
	password_modal_current_label: '現在のパスワード:',
	password_modal_new_label: '新しいパスワード:',
	password_modal_confirm_label: 'パスワードの確認：',
	password_modal_update: '更新',
	password_modal_cancel: 'キャンセル',
	personal_modal_title: '個人情報の更新',
	personal_modal_email: 'Eメール',
	personal_modal_password: 'パスワード',
	personal_modal_birth: '生年月日',
	personal_modal_social: 'ソーシャル サービスへの接続',
	personal_modal_firstname: '名',
	personal_modal_lastname: '姓',
	personal_modal_country: '国/地域',
	personal_modal_postalcode: '郵便番号',
	personal_modal_zipcode: '郵便番号',
	personal_modal_postalcode_invalid_message: '有効な郵便番号を入力してください',
	personal_modal_zipcode_invalid_message: '有効な郵便番号を入力してください',
	personal_modal_update: '更新',
	personal_modal_cancel: 'キャンセル',

	// payflow
	payflow_profile_name: '名前',
	payflow_profile_email: 'Eメール',

	// account page
	header_menu_account_my_account: 'マイ アカウント',
	header_menu_account_manage_account: 'アカウントの管理',
	header_menu_account_favorite_teams: 'お気に入りのチーム',
	header_menu_account_favorite_players: 'お気に入りの選手',
	header_menu_account_viewing_history: '視聴履歴',
};
